<script setup lang="ts">
import { IconExternalLink } from '@tabler/icons-vue';
import { computed } from 'vue';

import { FinancingFlowApi } from '~/services/financing-flow-api/financing-flow.types';

interface Emits {
  (_e: 'cancel-project'): void;
  (_e: 'open-platform'): void;
  (_e: 'resend-contract'): void;
  (_e: 'transfer-titularity'): void;
}

interface Props {
  enabledResendContract: boolean;
  financing: { data: FinancingFlowApi.FinancingV2 };
  isCancelLoading: boolean;
  isThrottled: boolean;
  loadingProject: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const isCancelable = computed(() => props.financing.data.status !== 'canceled'
  && props.financing.data.status !== 'expired'
  && props.financing.data.status !== 'reproved'
  && props.financing.data.step !== 'simulation'
  && !props.financing.data.installed_at);

const isCancelDisabled = computed(
  () => props.loadingProject || props.isCancelLoading,
);
</script>

<template>
  <div class="financing-actions">
    <button
      v-if="isCancelable"
      v-permission="['cancel_project:view']"
      class="btn btn-danger"
      type="button"
      :disabled="isCancelDisabled"
      @click="emit('cancel-project')"
    >
      Cancelar projeto
    </button>
    <button
      class="btn btn-outline-primary d-flex align-items-center gap-2"
      type="button"
      :disabled="!enabledResendContract || isThrottled"
      @click="emit('resend-contract')"
    >
      Reenviar Contrato
      <span v-if="isThrottled" class="spinner-border spinner-border-sm" role="status" />
    </button>
    <button
      v-permission="['tech_n1_support:edit']"
      class="btn btn-outline-primary"
      type="button"
      @click="emit('transfer-titularity')"
    >
      Trocar titularidade
    </button>
    <button class="btn btn-primary d-flex align-items-center gap-2" type="button" @click="emit('open-platform')">
      <IconExternalLink :size="16" />
      Abrir na Plataforma
    </button>
  </div>
</template>

<style scoped lang="scss">
.financing-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}
</style>
